import { render, staticRenderFns } from "./cta_button.vue?vue&type=template&id=fa2e13b4&scoped=true&"
import script from "./cta_button.vue?vue&type=script&lang=js&"
export * from "./cta_button.vue?vue&type=script&lang=js&"
import style0 from "./cta_button.vue?vue&type=style&index=0&id=fa2e13b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2e13b4",
  null
  
)

export default component.exports